import React, { useState } from 'react';
import { FaEye, FaEyeSlash, FaLeaf, FaLock, FaUser } from 'react-icons/fa';
import API_BASE_URL from '../../config/api';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        onLogin(data);
      } else {
        setError(data.error || 'Usuário ou senha inválidos');
      }
    } catch {
      setError('Erro ao conectar ao servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Painel esquerdo — identidade */}
      <div className="login-panel-left">
        <div className="login-brand">
          <img src="/img/gma.png" alt="GMA" className="login-logo-big" />
          <h1 className="login-brand-title">GMA</h1>
          <p className="login-brand-subtitle">Gestão em Meio Ambiente</p>
        </div>

        <div className="login-features">
          <div className="login-feature-item">
            <FaLeaf className="login-feature-icon" />
            <span>Licenciamento Ambiental</span>
          </div>
          <div className="login-feature-item">
            <FaLeaf className="login-feature-icon" />
            <span>Controle de Processos</span>
          </div>
          <div className="login-feature-item">
            <FaLeaf className="login-feature-icon" />
            <span>Gestão de Atividades CNAE</span>
          </div>
        </div>

        <div className="login-panel-decoration">
          <svg viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="40" cy="160" r="80" fill="rgba(116,198,157,0.07)" />
            <circle cx="260" cy="40" r="60" fill="rgba(116,198,157,0.05)" />
            <circle cx="150" cy="180" r="100" fill="rgba(82,183,136,0.04)" />
          </svg>
        </div>
      </div>

      {/* Painel direito — formulário */}
      <div className="login-panel-right">
        <div className="login-form-wrapper">
          <div className="login-form-header">
            <h2 className="login-form-title">Bem-vindo</h2>
            <p className="login-form-desc">Faça login para acessar o sistema</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="login-error">
                {error}
              </div>
            )}

            <div className="login-field">
              <label htmlFor="email">E-mail</label>
              <div className="login-input-wrapper">
                <FaUser className="login-input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="seu@email.com"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="password">Senha</label>
              <div className="login-input-wrapper">
                <FaLock className="login-input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="login-pw-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <span className="login-spinner" />
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <p className="login-footer-text">
            © {new Date().getFullYear()} Sistema GMA — Gestão de Meio Ambiente
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
